"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowAPI = void 0;
var fetchExperiments_1 = require("../fetchExperiments");
var FlowAPI = /** @class */ (function () {
    function FlowAPI(_a) {
        var experimentsConfig = _a.experimentsConfig, prepopulatedData = _a.prepopulatedData;
        this.reportError = function (error) {
            console.warn("You are trying to report an error, but didn't configure sentry in `.application.json`\n\nPlease read the docs for more information https://bo.wix.com/pages/yoshi/docs/editor-flow/structure-api/app-configuration/#applicationjson", 'Error: ', error);
        };
        var prepopulatedExperiments = prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.experiments;
        if (prepopulatedExperiments || !experimentsConfig) {
            this.getExperiments = fetchExperiments_1.initLoadedExperimentsGetter(prepopulatedExperiments);
        }
        else {
            this.getExperiments = fetchExperiments_1.initExperimentsGetter(experimentsConfig);
        }
    }
    return FlowAPI;
}());
exports.FlowAPI = FlowAPI;
//# sourceMappingURL=Base.js.map